import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
   name: 'currencyInWords'
})

export class CurrencyInWords implements PipeTransform {

  transform(value: number): string {
    if (value !== null && value !== undefined) {
      const amount = value.toString();
      const amountSplit = amount.split(".");

      const integerPart = amountSplit[0];
      const decimalPart = amountSplit[1];

      const words =
        numToWords(parseInt(integerPart, 10)) +
        (decimalPart ? ' and ' + decimalPart.padEnd(2, '0') + '/100' : '');

      return this.toTitleCaseExceptAnd(words);
    } else {
      return '';
    }
  }

  private toTitleCaseExceptAnd(text: string): string {
    return text.replace(/\w\S*/g, (word) => {
      if (word.toLowerCase() === 'and') {
        return 'and';
      }
      return word.charAt(0).toUpperCase() + word.slice(1);
    });
  }

}

const arr = x => Array.from(x);
const num = x => Number(x) || 0;
const str = x => String(x);
const isEmpty = xs => xs.length === 0;
const take = n => xs => xs.slice(0,n);
const drop = n => xs => xs.slice(n);
const reverse = xs => xs.slice(0).reverse();
const comp = f => g => x => f (g (x));
const not = x => !x;
const chunk = n => xs =>
  isEmpty(xs) ? [] : [take(n)(xs), ...chunk (n) (drop (n) (xs))];
let numToWords = n => {
  let a = [
    '', 'one', 'two', 'three', 'four',
    'five', 'six', 'seven', 'eight', 'nine',
    'ten', 'eleven', 'twelve', 'thirteen', 'fourteen',
    'fifteen', 'sixteen', 'seventeen', 'eighteen', 'nineteen'
  ];
  let b = [
    '', '', 'twenty', 'thirty', 'forty',
    'fifty', 'sixty', 'seventy', 'eighty', 'ninety'
  ];
  let g = [
    '', 'thousand', 'million', 'billion', 'trillion', 'quadrillion',
    'quintillion', 'sextillion', 'septillion', 'octillion', 'nonillion'
  ];
  
  let makeGroup = ([ones,tens,huns]) => {
    return [
      num(huns) === 0 ? '' : a[huns] + ' hundred ',
      num(ones) === 0 ? b[tens] : b[tens] && b[tens] + '-' || '',
      a[tens+ones] || a[ones]
    ].join('');
  };
  
  let thousand = (group,i) => group === '' ? group : `${group} ${g[i]}`;

  if (typeof n === 'number') return numToWords(String(n));
  if (n === '0')             return 'zero';
  return comp (chunk(3)) (reverse) (arr(n))
    .map(makeGroup)
    .map(thousand)
    .filter(comp(not)(isEmpty))
    .reverse()
    .join(' ');
};
